import {defineRecipe} from "@chakra-ui/react";

export const tabsRecipe = defineRecipe({
    variants: {
        variant: {
            searchBar: {
                list: {
                    borderColor: "#d3d3d3",
                    _horizontal: {
                        borderBottomWidth: "1px",
                    },
                },
                trigger: {
                    color: "#d3d3d3",
                    _selected: {
                        color: "white",
                        fontWeight: '900 !important',
                        _horizontal: {
                            layerStyle: "indicator.bottom",
                            "--indicator-offset-y": "-1px",
                            "--indicator-color": "white",
                        },
                    },
                },
            },
        },
    },
})
